<template lang="pug">
  .main(style="height: 100vh")
    el-row(style="height: 100vh")
      el-col.menu__container(:span="isMenuCollapsed ? 1 : 4")
        .balance__container
          .balances__block
            .balance__block.color-success
              i.el-icon-coin(v-if="!isMenuCollapsed")
              span {{ formatBalance(balances.available) }}
              span(v-if="!isMenuCollapsed") {{ cryptoType }}
            .balance__block.color-primary
              i.el-icon-coin(v-if="!isMenuCollapsed")
              span {{ formatBalance(balances.frozen) }}
              span(v-if="!isMenuCollapsed") {{ cryptoType }}
            .balance__block.color-danger
              i.el-icon-coin(v-if="!isMenuCollapsed")
              span {{ formatBalance(balances.unconfirmed) }}
              span(v-if="!isMenuCollapsed") {{ cryptoType }}
            .balance__block(
              v-if="isSuperadmin"
              :class="amlBalanceStale ? 'color-warning' : 'color-info'"
              :title="amlBalanceStale ? 'Баланс AML не обновлялся более двух минут' : ''")
              span.aml-balance__icon(v-if="!isMenuCollapsed") AML
              span {{ formatAmlBalance(amlBalance) }}
              span(v-if="amlBalanceStale && !isMenuCollapsed")  устар.
        .menu__block
          el-menu.el-menu-vertical-demo.menu__list(:default-active="activeMenu" :collapse="isMenuCollapsed" :collapse-transition="false")
            .menu-width-handler__container(@click="handleFullMenuStatus" :class="{ collapsed: isMenuCollapsed }")
              i.el-icon-caret-right(v-if="isMenuCollapsed")
              i.el-icon-caret-left(v-else)
            router-link(
              v-for="(menu, key) in availableMenus"
              :to="{name: menu.name}"
              :key="`menu-${menu.name}`"
              tag="div")
              el-menu-item(:index="`${key}`")
                i(:class="menu.icon")
                span(slot="title") {{ menu.title }}
            el-menu-item(:index="`${logoutIndex}`" @click="logout")
              i.el-icon-switch-button
              span(slot="title") Выйти
      el-col(:span="isMenuCollapsed ? 23 : 20" style="height: 100vh")
        router-view
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { CHANGE_RELOAD_STATUS } from '../../store/const/index';
  import { AUTH_LOGOUT } from '@/store/const/user';
  import instruments from '../../mixins/instruments';
  import { LOAD_AML_BALANCE, LOAD_BALANCES } from "@/store/const/node";

  export default {
    name: "Index",
    mixins: [
        instruments,
    ],
    data() {
      return {
        menuList: [
          {
            name: 'Deposits',
            title: 'Пополнения',
            icon: 'el-icon-sold-out',
            access: ['superadmin', 'admin', 'support', 'client']
          },
          {
            name: 'Withdraws',
            title: 'Выводы',
            icon: 'el-icon-sell',
            access: ['superadmin', 'admin', 'support', 'client']
          },
          {
            name: 'Wallets',
            title: 'Кошельки',
            icon: 'el-icon-wallet',
            access: ['superadmin', 'admin', 'support', 'client']
          },
          {
            name: 'Users',
            title: 'Пользователи',
            icon: 'el-icon-user',
            access: ['superadmin', 'admin']
          },
          {
            name: 'Settings',
            title: 'Настройки',
            icon: 'el-icon-setting',
            access: ['superadmin']
          },
         ],
        intervalHandle: null,
        isMenuCollapsed: false,
        balances: {
          available: 0,
          frozen: 0,
          unconfirmed: 0,
        },
        amlBalance: null,
        amlBalanceUpdatedAt: null,
        amlBalanceNow: Date.now(),
      }
    },
    watch: {
      reload(reload) {
        if (reload) {
          this.changeReloadStatus({ status: false });
          this.$router.go();
        }
      }
    },
    async mounted() {
      await this.updateBalances();
      this.startInterval();
    },
    beforeDestroy() {
      this.stopInterval();
    },
    computed: {
      ...mapGetters('user', {
        role: 'getRole',
        isAdmin: 'isAdmin',
        isSuperadmin: 'isSuperadmin',
        isPartner: 'isPartner',
      }),
      ...mapGetters(['reload']),
      ...mapGetters('settings', ['cryptoType']),
      amlBalanceStale() {
        const updatedAt = Date.parse(this.amlBalanceUpdatedAt);
        return !Number.isFinite(updatedAt) || this.amlBalanceNow - updatedAt > 120000;
      },
      availableMenus() {
        return this.menuList.filter((menu) => menu.access.includes(this.role));
      },
      logoutIndex() {
        return this.availableMenus.length;
      },
      activeMenu() {
        let activeMenu = '0';
        const activeRoute = this.$route.meta.menu || this.$route.name;
        for (let i = 0; i < this.menuList.length; i++) {
          const menu = this.menuList[i];
          if (activeRoute === menu.name) {
            activeMenu = '' + i;
            break;
          }
        }
        return activeMenu;
      }
    },
    methods: {
      ...mapActions({
        changeReloadStatus: CHANGE_RELOAD_STATUS,
      }),
      ...mapActions('user', {
        logoutRequest: AUTH_LOGOUT,
      }),
      ...mapActions('node', {
        loadBalances: LOAD_BALANCES,
        loadAmlBalance: LOAD_AML_BALANCE,
      }),
      async logout() {
        const request = await this.logoutRequest();
        if (!request?.success) {
          this.$message.error(
            `Ошибка выхода: ${request?.message || 'Не удалось завершить сессию на сервере'}`,
          );
        }
      },
      handleFullMenuStatus() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
      },
      async updateBalances () {
        const [request, amlRequest] = await Promise.all([
          this.loadBalances(),
          this.isSuperadmin ? this.loadAmlBalance() : null,
        ]);
        if (request.success) {
          const data = request.data || {};
          this.balances.available = data.available !== undefined && data.available !== null
            ? data.available
            : data.confirmed || 0;
          this.balances.frozen = data.frozen || 0;
          this.balances.unconfirmed = data.unconfirmed || 0;
        }
        if (amlRequest && amlRequest.success) {
          this.amlBalance = amlRequest.data?.checksAvailable ?? null;
          this.amlBalanceUpdatedAt = amlRequest.data?.updatedAt || null;
        }
        this.amlBalanceNow = Date.now();
      },
      formatBalance(value) {
        const accuracy = this.isMenuCollapsed ? 4 : 8;
        return Number(value || 0).toFixed(accuracy);
      },
      formatAmlBalance(value) {
        return value === null ? '-' : value;
      },
      startInterval() {
        this.stopInterval();
        this.intervalHandle = setInterval(() => {
          this.updateBalances();
        }, 10000);
      },
      stopInterval() {
        if (this.intervalHandle) {
          clearInterval(this.intervalHandle);
          this.intervalHandle = null;
        }
      },
    }
  }
</script>

<style lang="scss">
	.main {
		text-align: left;
	}

  .menu__list {
    height: 100%;
  }

  .mode-select__container {
    padding: 10px 0;
    margin: auto;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
  }

  .mode-select__container .title {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .module__main {
    overflow-y: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .module__title {
    font-size: 20px;
    height: 29px;
    padding: 10px;
    background-color: #efefef;
    text-shadow: 1px 1px 1px #cce0f1;
    color: #05447a;
    font-weight: bold;
    text-align: center;
  }

  .module-content__container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    background-color: #e3e0e0;
    border-left: 1px solid #d1cece;
    border-top: 1px solid #d1cece;
    overflow-y: hidden;
    height: 100%;
  }

  .menu__container {
    display: flex;
    height: 100vh;
    flex-direction: column;
    background-color: #efefef;
    padding: 4px;
  }

  .menu__block {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF;
    border-right: solid 1px #e6e6e6;
    justify-content: space-between;
  }

  .menu-width-handler__container {
    cursor: pointer;
    width: 100%;
    text-align: right;
  }

  .menu-width-handler__container.collapsed {
    text-align: center;
  }

  .menu-width-handler__container:hover {
    background-color: #f7f7f7;
  }

  .table__container {
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
  }

  .table-list__container {
    overflow-y: scroll;
    border-radius: 5px;
  }

  .table-pagination__container {
    margin-bottom: 5px;
    text-align: center;
  }

  .table-list__container .val {
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .color-success {
    color: #67C23A;
  }

  .background-success {
    background-color: #67C23A;
  }

  .color-warning {
    color: #E6A23C;
  }

  .background-warning {
    background-color: #E6A23C;
  }

  .color-danger {
    color: #F56C6C;
  }

  .background-danger {
    background-color: #F56C6C;
  }

  .color-info {
    color: #909399;
  }

  .background-info {
    background-color: #909399;
  }

  .color-primary {
    color: #409EFF;
  }

  .background-primary {
    background-color: #409EFF;
  }

  tr.row-success {
    background-color: #c4f8ae !important;
  }

  tr.row-danger {
    background-color: #fcbbbb !important;
  }

  .balance__container {
    padding: 4px;
    margin: 3px auto;
    font-size: 12px;
    background-color: white;
    width: calc(100% - 10px);
    text-align: center;
    border-bottom: 1px solid #c9c9c9;
  }

  .balance__title {
    margin-right: 5px;
  }

  .balances__block {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .balance__block {
    margin: 1px 2px;
  }

  .aml-balance__icon {
    border: 1px solid currentColor;
    padding: 0 2px;
    margin-right: 4px;
    font-size: 9px;
    font-weight: bold;
  }
</style>

